/**
 * Hook to fetch the current user for permission checks.
 */
import { useState, useEffect, useCallback } from 'react';
import { apiFetch } from '../../shared/hooks/useApi';
// @ts-ignore — CommonJS module from @scoutfdc/common
const { ignore_security_groups: PRIVILEGE_SUPER_ADMIN, support_user: PRIVILEGE_SUPPORT } = require('@scoutfdc/common/lib/privilege_level');
// @ts-ignore — CommonJS module from @scoutfdc/common
const { user_edit: ACCESS_RIGHT_USER_EDIT } = require('@scoutfdc/common/lib/access_rights');
export function useCurrentUser() {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const load = useCallback(async () => {
        try {
            const response = await apiFetch('/api/users/current');
            setUser(response.users);
        }
        catch (_a) {
            setUser(null);
        }
        finally {
            setLoading(false);
        }
    }, []);
    useEffect(() => { load(); }, [load]);
    const permissions = (() => {
        if (!user) {
            return { canViewAll: false, canViewGeneralOnly: false, canAccess: false };
        }
        const isSuperAdmin = user.privilege === PRIVILEGE_SUPER_ADMIN;
        const isSupport = user.privilege === PRIVILEGE_SUPPORT;
        const hasUserEdit = (user.access_rights & ACCESS_RIGHT_USER_EDIT) !== 0;
        const canViewAll = isSuperAdmin || isSupport;
        const canViewGeneralOnly = hasUserEdit && !canViewAll;
        const canAccess = canViewAll || hasUserEdit;
        return { canViewAll, canViewGeneralOnly, canAccess };
    })();
    return { user, loading, permissions };
}
